module.exports = __webpack_public_path__ + "img/SketchPng1b873447787c9cbb3e41368859a9d2c662c59bd8506395ceca20ebd4c958e4c0.800b6e9b.png";